import React, { PureComponent, SyntheticEvent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { GrayContainer } from '../../ui/containers';
import { Input } from '../../ui/forms';

const Title = styled.h1`
  font-size: 18px;
  color: white;
  text-shadow: 1px 1px 3px #000;
`;

const SearchButton = styled.button`
  color: #ccc;
  cursor: pointer;
  font-size: 18px;
  background: transparent;
  border: none;
  height: 32px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const InputContainer = styled.div`
  display: flex;
  width: 40%;
  align-items: center;
`;

class SearchBar extends PureComponent {
  props: {
    title: string,
    query: Object,
    onChangeQuery: Function,
  }

  render() {
    return (
      <GrayContainer>
        <Title>{this.props.title}</Title>
        <InputContainer>
          <Input
            outlineColor={this.props.page && this.props.page.color_base}
            placeholder="Carácteristicas ó Código"
            value={this.props.query.cod}
            onChange={(event: SyntheticEvent) => {
              this.props.onChangeQuery({
                ...this.props.query,
                page: 0,
                code: event.target.value,
              });
            }}
          />
          <SearchButton><i className="icon-seach" /></SearchButton>
        </InputContainer>
      </GrayContainer>
    );
  }
}

export default connect(state => ({
  page: state.client.pageInfo && state.client.pageInfo.page,
}))(SearchBar);



// WEBPACK FOOTER //
// ./src/components/BuildingsView/SearchBar/index.js